module.exports = __webpack_public_path__ + "static/jaune1-cbc9f46f91eb44f05a871fcfab5b87f6.jpg";